// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_1onIU"};